import React from "react";
import Images from "../../Component/Simage";
import DepinCustomMap from "./DepinCustomMap";

function DepinMap() {
  return (
    <div className="depin_map">
      <div className="map_sec">
        <p className="pre-title fw-500 text-center mb-0">The AInfra DCDN</p>
        <p className="title fw-700 mb-0 text-center">Nodes around the world</p>
        <p className="mt-2 fw-700 mb-0 text-center">Currently, only selected regions can participate in LaunchX. The purchase restrictions will be gradually lifted over time.</p>
        <div className="map">

          <div className="map_status_container">
            <p className="status_text">Availability</p>
            <div className="map_single_status">
              <div className="status_indicator available"></div>
              <p className="status_text">Available</p>
            </div>
            <div className="map_single_status">
              <div className="status_indicator coming_soon"></div>
              <p className="status_text">Coming soon</p>
            </div>
          </div>
          <DepinCustomMap />
        </div>
      </div>
    </div>
  );
}

export default DepinMap;
